import DashboardProvider, { DashboardContext } from "./DashboardProvider";

export type { AnsweredQuestion, DashboardQueryAnswer, DefaultQueryTemplate } from "./DashboardProvider";

export { DashboardContext };

export default DashboardProvider;